import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    fontSize: theme.size.sm,

    '& svg': {
      marginRight: 5
    },

    '& > div': {
      padding: '4px 8px',
      borderRadius: 50,
      userSelect: 'none',
      display: 'inline-flex',
      flexDirection: 'row',
      alignItems: 'center'
    }
  },

  published: {
    backgroundColor: '#D2FFC7',
    color: '#5CC043'
  },

  draft: {
    backgroundColor: '#FFE5A3',
    color: '#D4A428'
  },

  unpublished: {
    backgroundColor: '#F0F0F0',
    color: '#8F8F8F'
  }
}))

export default useStyles
